export default __webpack_public_path__ + "static/media/flag_bttn.eca15abc.svg";